import {
  Dialog,
  DropdownOption,
  FloatingLabels,
  HIDDEN_INPUTS,
  MyTripFindTripBy,
  SearchTrip
} from '@com-delta-idp/mnx-capability-trip-management-ui';
import { MyTripAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  NameField,
  PopUpModal,
  SearchField
} from '@com-delta-idp/mnx-sitewide-shared-utils';
import { myTripFormGroup } from '../utils/mytrip-form.utils';
export const createList = (list: SearchField[]): DropdownOption[] =>
  list.map((item) => ({
    label: item.label,
    value: item.value
  }));

export const getSearchContent = (
  aem: MyTripAem,
  formActionUrl: string,
  count: string,
  nameLengthConfig?: boolean
): SearchTrip => {
  return {
    backToUpcomingTripLabel: aem.backToUpcomingTripLabel,
    findYourTripBy: aem.findYourTripBy,
    dropdownId: 'trip-finder-dropdown',
    dropdownPlaceholder: 'Select option',
    searchCTA: aem.searchCTA,
    formError: aem.formError,
    option: createList(aem.dataList),
    nameList: aem.nameList,
    dataList: aem.dataList,
    displayBackLink: Number(count) > 0,
    formGroup: myTripFormGroup(nameLengthConfig),
    submitClicked: false,
    currentType: MyTripFindTripBy.CONFIRMATION_NUMBER,
    errorCount: 0,
    hiddenInputs: HIDDEN_INPUTS,
    floatingLabels: floatingLabelList([...aem.dataList, ...aem.nameList]),
    formAttributes: {
      formAction: formActionUrl,
      isCreditCardSelected: false
    }
  };
};

export const floatingLabelList = (
  list: SearchField[] | NameField[]
): FloatingLabels => {
  const labels: FloatingLabels = {};
  for (const item of list) {
    labels[item.value] = '';
  }
  return labels;
};

export const modalContent = (popup: PopUpModal): Dialog => {
  return {
    title: popup.title,
    description: popup.description
  };
};
